import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import { getRoles } from '../../../../services/RoleService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  getModuleToRole,
  getModuleToRoleById,
  updateModuleToRole,
} from '../../../../services/ModuleToRoleService';

// Define module options with operations
const moduleOptions = [
  { value: 'forms', label: 'Forms', operations: ['menu', 'view'] },
  { value: 'settings', label: 'Settings', operations: ['menu', 'view'] },
  { value: 'report', label: 'Report', operations: ['menu', 'read', 'export'] },
  { value: 'coi-report', label: 'COI Report', operations: ['menu', 'read', 'export'] },
  {
    value: 'dashboard',
    label: 'Dashboard',
    operations: [
      'menu',
      'read',
      'write',
      'edit',
      'delete',
      'export',
      'import',
      'jha-filter',
      'voucher-filter',
      'tripreport-filter',
      'award-filter',
      'coi-filter',
      'aea-filter',
    ],
  },
  {
    value: 'jha-form',
    label: 'JHA form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'voucher-form',
    label: 'Voucher form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'tripreport-form',
    label: 'Trip report form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'award-form',
    label: 'Award form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'aea-form',
    label: 'AEA form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'coi-form',
    label: 'COI form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'requisition-form',
    label: 'Requisition form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'training-form',
    label: 'Training form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'skills-form',
    label: 'Skills form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import', 'employeelist'],
  },
  {
    value: 'skills-dashboard',
    label: 'Skills Dashboard',
    operations: ['menu', 'read', 'fulldashboard'],
  },
  {
    value: 'offer-form',
    label: 'Offer form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'mcft-form',
    label: 'MCFT form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'eww-form',
    label: 'EWW form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'shs-form',
    label: 'SHS form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'fsr-form',
    label: 'FSR form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  { value: 'box-folders', label: 'Box Folder', operations: ['menu', 'show'] },
  {
    value: 'account-code-settings',
    label: 'Account Code Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'jha-job-settings',
    label: 'JHA Job Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'mtr-settings',
    label: 'MTR Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'project-code-settings',
    label: 'Project Code Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'roles-settings',
    label: 'Roles Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'fbr-settings',
    label: 'FBR Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'box-folders-settings',
    label: 'Box Folders Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'mte-settings',
    label: 'MTE Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'user-settings',
    label: 'User Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'task-number-settings',
    label: 'Task Number Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'award-type-settings',
    label: 'Award Type Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'award-ceremony-settings',
    label: 'Award ceremony Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'award-history-settings',
    label: 'Award History Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: ' training-history-settings',
    label: 'Training History Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'tuition-settings',
    label: 'Tuition Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'course-type-settings',
    label: 'Course Type Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'skill-category-settings',
    label: 'Skill Category Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'skill-expertise-settings',
    label: 'Skill Expertise Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'skills-settings',
    label: 'Skills Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'jobtitle-settings',
    label: 'Job Title Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'jobtype-settings',
    label: 'Job Type Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'subcontractor-settings',
    label: 'Subcontractor Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
];

const EditModuleToRole = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Assuming the role ID is passed as a URL parameter
  const [roleList, setRoleList] = useState([]);
  const [formData, setFormData] = useState({
    roleSlug: '',
    modules: [], // Store selected modules with operations
  });

  useEffect(() => {
    const fetchData = async () => {
      const roles = await getRoles();
      setRoleList(roles);

      if (id) {
        const moduleToRole = await getModuleToRoleById(id);
        setFormData({
          roleSlug: moduleToRole.roleSlug,
          modules: moduleToRole.modules,
        });
      }
    };
    fetchData();
  }, [id]);

  const handleModuleChange = (selectedModules) => {
    setFormData((prevState) => ({
      ...prevState,
      modules: selectedModules.map((module) => ({
        ...module,
        operations: prevState.modules.find((m) => m.value === module.value)?.operations || [],
      })),
    }));
  };

  const handleOperationsChange = (selectedOperations, module) => {
    setFormData((prevState) => ({
      ...prevState,
      modules: prevState.modules.map((m) =>
        m.value === module.value
          ? { ...m, operations: selectedOperations.map((op) => op.value) }
          : m
      ),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateModuleToRole(id, {
        roleSlug: formData.roleSlug,
        modules: formData.modules.map((module) => ({
          value: module.value,
          operations: module.operations,
        })),
      });
      // Show success toast notification
      toast.success('Module added Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate('/settings/mtr');
      }, 3000);
      console.log('Module updated successfully');
    } catch (error) {
      console.error('Error updating role:', error);
      toast.error('Failed to adding Module !', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  const roleOptions = roleList.map((role) => ({
    value: role.slug,
    label: role.label,
  }));

  const moduleOptionsWithOperations = moduleOptions.map((module) => ({
    value: module.value,
    label: module.label,
  }));

  const operationOptions = moduleOptions.reduce((acc, module) => {
    acc[module.value] = module.operations.map((op) => ({
      value: op,
      label: op.charAt(0).toUpperCase() + op.slice(1),
    }));
    return acc;
  }, {});

  return (
    <>
      <h4 className="box-title">Edit Module Details</h4>
      <Form id="userUpdateForm" onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group controlId="formRoleSlug">
              <Form.Label>Role</Form.Label>
              <Select
                name="roleSlug"
                value={roleOptions.find((option) => option.value === formData.roleSlug)}
                onChange={(option) =>
                  setFormData((prevState) => ({
                    ...prevState,
                    roleSlug: option ? option.value : '',
                  }))
                }
                options={roleOptions}
                placeholder="Select Role"
              />
            </Form.Group>
          </Col>
          <Col md={9}>
            <Form.Group controlId="formModules">
              <Form.Label>Modules</Form.Label>
              <Select
                isMulti
                name="modules"
                value={formData.modules.map((m) => ({
                  value: m.value,
                  label:
                    m.value.replace('-', ' ').charAt(0).toUpperCase() +
                    m.value.replace('-', ' ').slice(1),
                }))}
                onChange={handleModuleChange}
                options={moduleOptionsWithOperations}
                placeholder="Select Modules"
              />
            </Form.Group>
            {formData.modules.map((module) => (
              <div key={module.value} className="mb-3">
                <Form.Label>
                  Operations for{' '}
                  {module.value.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}
                </Form.Label>
                <Select
                  isMulti
                  name={`operations-${module.value}`}
                  value={module.operations.map((op) => ({
                    value: op,
                    label: op.charAt(0).toUpperCase() + op.slice(1),
                  }))}
                  onChange={(selectedOperations) =>
                    handleOperationsChange(selectedOperations, module)
                  }
                  options={operationOptions[module.value]}
                  placeholder="Select Operations"
                />
              </div>
            ))}
          </Col>
        </Row>
        <div className="d-flex justify-content-end">
          <Button variant="warning" className="me-1" onClick={() => navigate('/settings/mtr')}>
            <i className="ti ti-trash"></i> Cancel
          </Button>
          <Button variant="primary" type="submit">
            <i className="ti ti-save-alt"></i> Save
          </Button>
        </div>
      </Form>
      <ToastContainer />
    </>
  );
};

export default EditModuleToRole;
